module.exports = __webpack_public_path__ + "img/qrHeader.a989d891.png";